import React, { useRef, useState } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import {useEffect } from "react";
import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, Switch, Toolbar, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import BankForm from "./BankForm";

const Bank = () => {

    const gridRef = useRef()
    const childRef = useRef()

    const [rowData , setRowData]= useState([])
    const [snackState, setSnackState] = useState(false);
    const [openBank, setOpenBank] = useState(false)
    const [successMsg, setSuccessMsg] = useState();
    const [error, setError] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [columnDefs , setColumnDefs] = useState([
        { field: 'bank', headerName: 'Bank' },
        { field: 'bankIdentifierCode', headerName: 'Bank Identifier Code', minWidth: 200, },
        { field: 'bankAddress', headerName: 'Bank Address', minWidth: 200, },
        { field: 'issuingBankName', headerName: 'Issuing Bank Name', minWidth: 200,},
    ]);
    const bankUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.bankInfoes}`;

    const handleAddButton = () => {
        setOpenBank(true)
    }

    const loadBankData = async () => {
        try {
            let list = await OAuthService.getList(bankUrl);
            if (list.data) {
                const listData = list.data._embedded.bankInfoes.map((data) => {
                 
                    return data
                })
                setRowData(listData)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }
    const onGridReady = () => {
        loadBankData()
    }

    const handleSave = () => {
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                handleFormClose()
                loadBankData();
            }
        })
    }

    const handleFormClose = () => {
        setOpenBank(false);
    }

    const handlecreateSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    const closeOpenBank = () => {
        setOpenBank(false);
    }

    const onSelectionChanged = (params) => {
        let select = params.api.getSelectedRows()
        setSelectedRows(select);
    }

    const handleEdit = () => {
        setOpenBank(true)
    }

    const handleDeleteBank = async () => {
        console.log("delete", selectedRows);
        const id = selectedRows.length > 0 && selectedRows[0]._links?.self?.href.split('/').pop();
        console.log(id);
        try {
            const deleteUsance = await OAuthService.deleteData(bankUrl, id)

                loadBankData();
                setSuccessMsg("Bank deleted successfully.")
                setSnackState(true)
                setDeleteOpen(false)
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const checkSaveDisabled = (value) => {
        setSaveDisabled(value)
    }
    
    useEffect(()=>{
        checkSaveDisabled()
    },[])


    const bankInputField = () => {
        return <>
            <Tooltip title={"Add Bank"}>
                <Button
                    variant="contained"
                    color="warning"
                    style={{ marginLeft: "4px" }}
                    onClick={handleAddButton}
                >
                    <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                </Button>
            </Tooltip>
            {(selectedRows && selectedRows.length > 0) &&
                <>
                    <Tooltip title={"Edit Bank"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleEdit}
                        >
                            <FuseSvgIcon>material-solid:edit</FuseSvgIcon>
                        </Button>
                    </Tooltip>
                </>
            }
        </>
    }

    return (
        <>
        <ListPageHeader
                componentName={'Bank'}
                pageName={'Bank'}
                headerInputFields={bankInputField()}
                gridRef={gridRef}
                successMsg={successMsg}
                snackState={snackState}
                deleteDisable={selectedRows.length > 0 ? false :true}
                handlePurge={handleDeleteBank}
            />
            <AgGridTable
            gridRef={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                onSelectionChanged={onSelectionChanged}
                onGridReady={onGridReady}

            />
             <Dialog
                fullWidth={true}
                PaperProps={{
                    sx: {
                        minHeight: 200,
                        Width: 150
                    }
                }}
                maxWidth={'sm'}
                onClose={handleFormClose}
                open={openBank}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                        {(selectedRows && selectedRows.length > 0) ? "Update Bank" : "Add Bank"}
                        </Typography>
                        <Button onClick={handleFormClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <BankForm
                        open={openBank}
                        ref={childRef}
                        handleClose={closeOpenBank}
                        successMsg={handlecreateSuccessMsg}
                        select={selectedRows}
                        checkSaveDisabled={checkSaveDisabled} />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSave}
                        disabled={saveDisabled}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog>
            </>
    )
}

export default Bank